import Layout from '@/views/mainLayout/Layout.vue';

// 自动导入业务路由
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('./', true, /(?<!index)\.js$/);
const asyncRouters = [];
requireAll(req).map((md) => {
    asyncRouters.push(md.default);
    return 0;
});

export default {
    path: '/layout',
    component: Layout,
    children: asyncRouters,
};
